export default "__VITE_ASSET__dtAPQYiB__"